import { classNames, doNothing } from "@greeter/util";

import css from "./TimeInput.module.scss";
import { TimeOfDay } from "@greeter/date";
import { Props } from "@greeter/matter";

export type TimeInputProps = Props & {
  value?: TimeOfDay;
  onChange?: (tod: TimeOfDay) => void;
  disabled?: boolean;
  placeholder?: string;
  theme?: "dark" | "light";
};

export function TimeInput({
  onChange = doNothing,
  disabled = false,
  placeholder = "Vælg tid",
  className,
  value,
  theme = "light",
  ...props
}: TimeInputProps) {
  return (
    <input
      type="time"
      onChange={(e) => {
        try {
          onChange(TimeOfDay.parse(e.target.value));
        } catch {
          console.warn(
            `Failed to parse ${e.target.value}. Defaulting to TimeOfDay.min()`
          );
          onChange(TimeOfDay.min());
        }
      }}
      value={value?.toString() ?? "00:00"}
      {...classNames(
        className,
        css.TimeInput,
        theme === "dark" && css.Dark,
        disabled ? css.Disabled : ""
      )}
      pattern="[0-9]{2}:[0-9]{2}"
      {...props}
    />
  );
}

export default TimeInput;
